import { render, staticRenderFns } from "./FormSelectBIUser.vue?vue&type=template&id=2bafe176&lang=pug"
import script from "./FormSelectBIUser.vue?vue&type=script&lang=js"
export * from "./FormSelectBIUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bafe176')) {
      api.createRecord('2bafe176', component.options)
    } else {
      api.reload('2bafe176', component.options)
    }
    module.hot.accept("./FormSelectBIUser.vue?vue&type=template&id=2bafe176&lang=pug", function () {
      api.rerender('2bafe176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/FormSelectBIUser.vue"
export default component.exports